import moment from 'moment-timezone';

import PriorityOptions from 'components/form/priority/Priority.enum';

import {Arrangement} from 'store/rootState';
import { ScheduledEventShow } from 'store/eventState';

// Shows are identified by their arrangement id, so an arrangement without one
// cannot become a show.
export type IdentifiedArrangement = Arrangement & { id: number };

export enum ShowPlaybackMode {
  REPETITION = 'repetition',
  TIME = 'time',
  LOOPING = 'looping',
}

export interface EventShow {
  arrangementId: number;
  playbackMode: ShowPlaybackMode;
  time: string;
  repetition: string;
}

export interface EventShowPayload {
  arrangement_id: number;
  playback_mode: ShowPlaybackMode;
  duration: number | null;
  repetition: number | null;
}

export interface EventProps {
  startDate: string;
  endDate: string;
  roundTime: boolean;
  id: number;
  title: string;
  rrule: string;
  arrangements?: ScheduledEventShow[];
  active: boolean;
  pending_approval: boolean;
  pending_changes?: any;
  priority: PriorityOptions;
}

export interface EventInitialValues {
  name: string,
  startDate: moment.Moment | null,
  startTime: moment.Moment | null,
  dateUntil?: string | Date | null,
  endDate: moment.Moment | null,
  endTime: moment.Moment | null,
  rrule: string,
  repeat: any;
  weeklyDays: any;
  dailyInterval: any;
  monthlyInterval: any;
  monthlyIntervalDay: any;
  monthlyDays: any;
  shows: EventShow[];
  priority: PriorityOptions;
}
